var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10937_195918",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10937_195918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.38367 11.7185C6.29478 11.7185 6.20867 11.7018 6.12533 11.6685C6.042 11.6352 5.96144 11.5796 5.88367 11.5018L3.067 8.68516C2.93367 8.55182 2.86978 8.38238 2.87533 8.17682C2.88089 7.97127 2.95033 7.80182 3.08367 7.66849C3.217 7.53516 3.38367 7.46849 3.58367 7.46849C3.78367 7.46849 3.95033 7.53516 4.08367 7.66849L6.417 10.0018L11.9337 4.48516C12.067 4.35182 12.2309 4.28516 12.4253 4.28516C12.6198 4.28516 12.7837 4.35182 12.917 4.48516C13.0503 4.61849 13.117 4.78238 13.117 4.97682C13.117 5.17127 13.0503 5.33516 12.917 5.46849L6.88367 11.5018C6.80589 11.5796 6.72533 11.6352 6.642 11.6685C6.55867 11.7018 6.47256 11.7185 6.38367 11.7185Z",
    fill: "#0047CC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlue);
export default __webpack_public_path__ + "static/media/check_blue.5f985bb49353d8dcb1aa344fc97db125.svg";
export { ForwardRef as ReactComponent };